import Movies from "./Movies";

export default Movies;
